module.exports = __webpack_public_path__ + "static/media/gloriaJoe70.0860a056.png";